import ActivationComponent from "../../Component/Activation/ActivationComponent";

const Activation=()=>{
return(
    <div className='page-body'>
    <ActivationComponent />
  </div>
)
}
export default Activation;